export const INITIAL_INDEX = -1
